// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__jubs9","itemTitle":"ClientEmergencyInfo_itemTitle__89li8","itemText":"ClientEmergencyInfo_itemText__1qRuW"};